import { Component, OnInit, Input } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { EMPTY, Subscription } from 'rxjs';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { CentersCentersService } from 'src/app/services/centers-services/centers-centers-service/centers-centers.service';
import { Router, ActivatedRoute } from '@angular/router';
import { SpinnerService } from 'src/app/components/shared-components/spinner/spinner.service';
import { MatDialog } from '@angular/material/dialog';
import { MultimediaManagerComponent } from 'src/app/modules/multimedia-manager/multimedia-manager/multimedia-manager.component';
import { TIMEZONES } from 'src/assets/timezones/timezones';
import { catchError } from 'rxjs/internal/operators/catchError';
import { tap } from 'rxjs/internal/operators/tap';
import { COUNTRIES } from 'src/assets/countries/countries';

@Component({
  selector: 'app-centers-new-center-creation-card',
  templateUrl: './centers-new-center-creation-card.component.html',
  styleUrls: ['./centers-new-center-creation-card.component.scss']
})
export class CentersNewCenterCreationCardComponent implements OnInit {

  @Input() centerTypeList;
  @Input() currencies;
  timezones;
  countries;
  imageUrl: string;
  showButton: boolean;
  addNewCenterSubscription: Subscription;
  basicDataForm = new FormGroup({
    visible: new FormControl(true, Validators.required),
    centerName: new FormControl(null, Validators.required),
    centerType: new FormControl(null, Validators.required),
    cif: new FormControl(null),
    code: new FormControl(null),
    fiscalName: new FormControl(null),
    fiscalAddress: new FormControl(null),
    street: new FormControl(null, Validators.required),
    zipCode: new FormControl(null, Validators.required),
    city: new FormControl(null, Validators.required),
    province: new FormControl(null, Validators.required),
    region: new FormControl(null, Validators.required),
    country: new FormControl(null, Validators.required),
    gpsLatitude: new FormControl(null, Validators.required),
    gpsLongitude: new FormControl(null, Validators.required),
    faxNumber: new FormControl(null),
    phoneNumber: new FormControl(null, Validators.required),
    centerMail: new FormControl(null, [Validators.required, Validators.email]),
    centerContactName: new FormControl(null, Validators.required),
    timeZone: new FormControl({ value: 'Europe/Madrid' }, Validators.required),
    currency: new FormControl(null, Validators.required)
  });

  constructor(private snackbarService: SnackBarService,
              private centersCentersService: CentersCentersService,
              private router: Router,
              public dialog: MatDialog,
              private activatedRoute: ActivatedRoute,
              private spinnerService: SpinnerService) {
                this.showButton = true;
                this.timezones = TIMEZONES;
                this.countries = COUNTRIES;
  }

  ngOnInit() { }

  public addNewCenter() {
    this.showButton = false;
    this.spinnerService.show('center-new-spinner');
    const validation = this.validateForm();
    if (validation === true) {
      this.addNewCenterSubscription = this.centersCentersService.addNewCenter(this.basicDataForm.get('visible').value, this.imageUrl, this.basicDataForm.get('centerName').value, this.basicDataForm.get('cif').value, this.basicDataForm.get('fiscalName').value, this.basicDataForm.get('fiscalAddress').value, this.basicDataForm.get('street').value, this.basicDataForm.get('zipCode').value, this.basicDataForm.get('city').value, this.basicDataForm.get('province').value, this.basicDataForm.get('region').value, this.basicDataForm.get('country').value, this.basicDataForm.get('gpsLatitude').value, this.basicDataForm.get('gpsLongitude').value, this.basicDataForm.get('faxNumber').value, this.basicDataForm.get('phoneNumber').value, this.basicDataForm.get('centerMail').value, this.basicDataForm.get('centerContactName').value, this.basicDataForm.get('centerType').value.InternalId, this.basicDataForm.get('code').value, this.basicDataForm.get('timeZone').value, this.basicDataForm.get('currency').value.InternalId).pipe(
        tap(o => this.showButton = true),
        tap(o => this.spinnerService.hide('center-new-spinner')),
        tap(o => this.snackbarService.open('stores-page.snackbar messages.add store success', 'success')),
        tap(o => this.router.navigate(['../centers'], { relativeTo: this.activatedRoute.parent })),
        catchError(error => { this.snackbarService.open(error['error']['message'], 'error'); return EMPTY; })
      ).subscribe();
    } else {
      this.showButton = true;
      this.spinnerService.hide('center-new-spinner');
      this.snackbarService.open(validation, 'error');
    }
  }

  public validateForm() {
    if (!this.imageUrl) {
      return 'stores-page.snackbar messages.image center error';
    } else if (!this.basicDataForm.get('centerName').valid) {
      return 'stores-page.snackbar messages.centerName stores error';
    }  else if (!this.basicDataForm.get('street').valid) {
      return 'stores-page.snackbar messages.street stores error';
    } else if (!this.basicDataForm.get('centerType').valid) {
      return 'stores-page.snackbar messages.centerType stores error';
    } else if (!this.basicDataForm.get('province').valid) {
      return 'stores-page.snackbar messages.province stores error';
    } else if (!this.basicDataForm.get('zipCode').valid) {
      return 'stores-page.snackbar messages.zipCode stores error';
    } else if (!this.basicDataForm.get('city').valid) {
      return 'stores-page.snackbar messages.city stores error';
    } else if (!this.basicDataForm.get('region').valid) {
      return 'stores-page.snackbar messages.region stores error';
    } else if (!this.basicDataForm.get('country').valid) {
      return 'stores-page.snackbar messages.country stores error';
    } else if (!this.basicDataForm.get('gpsLatitude').valid) {
      return 'stores-page.snackbar messages.gpsLatitude stores error';
    } else if (!this.basicDataForm.get('gpsLongitude').valid) {
      return 'stores-page.snackbar messages.gpsLongitude stores error';
    } else if (!this.basicDataForm.get('fiscalName').valid) {
      return 'stores-page.snackbar messages.fiscalName stores error';
    } else if (!this.basicDataForm.get('fiscalAddress').valid) {
      return 'stores-page.snackbar messages.fiscalAddress stores error';
    } else if (!this.basicDataForm.get('cif').valid) {
      return 'stores-page.snackbar messages.cif stores error';
    } else if (!this.basicDataForm.get('phoneNumber').valid) {
      return 'stores-page.snackbar messages.phoneNumber stores error';
    } else if (!this.basicDataForm.get('centerMail').valid) {
      return 'stores-page.snackbar messages.centerMail stores error';
    } else if (!this.basicDataForm.get('centerContactName').valid) {
      return 'stores-page.snackbar messages.centerContactName stores error';
    } else if (!this.basicDataForm.get('currency').valid) {
      return 'stores-page.snackbar messages.currency stores error';
    } else {
      return true;
    }
  }

  public cancelCenter() {
    this.router.navigate(['../centers'], { relativeTo: this.activatedRoute.parent });
  }

  public getSelectedCenter() {
    if (this.centerTypeList && this.centerTypeList.length > 0) {
      if (this.basicDataForm.get('centerType').value) {
        return this.basicDataForm.get('centerType').value.InternalId;
      } else {
        return null;
      }
    } else {
      return null;
    }
  }

  public setPreselected(op1, op2) {
    if (op1 && op2) {
      return op1.InternalId === op2.InternalId;
    }
  }

  public setPreselected2(op1, op2) {
    if (op1 && op2) {
      return op1 === op2;
    }
  }

  public uploadPhotoClicker() {
    const dialogRef = this.dialog.open(MultimediaManagerComponent, { data: { multi: false } });
    dialogRef.beforeClosed().subscribe(
      (result) => {
        if (result) {
          this.imageUrl = result[0].Url;
        }
      }
    );
  }
}
